// IF (07/07/20): Unless a customer has manually added (or we've manually uploaded) an employee who
// isn't also a user of the software, we don't consider them to have added any employees.
export const orgHasNotAddedEmployees = (employees: Array<Employee>) =>
  employees.every((e) => e.isAutomaticallyAdded || e.username);
